import { QRFC } from "./QRFC";

export class QBambooCallbackRFC extends QRFC {
  constructor() {
    super();
  }

  InitRFC() {
    this.InitRemoteCall(null, "POST", true, false);
  }

  GetCallName() {
    return "endpoints/qbamboocallback";
  }

  SetParams(subdomain, code, state) {
    this.AddParameter("subdomain", subdomain);
    this.AddParameter("code", code);
    this.AddParameter("state", state);
  }
}
